




































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "wirebill/list";

  dispatchTypeDelete: string = "wirebill/delete";
  deleteConfirmContent: string = "你确定要删除该记录吗？";

  // 操作搜索栏的展开和折叠
  isFlag = false;

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", scopedSlots: { customRender: "username" } },
    { title: "球线名称", scopedSlots: { customRender: "wire_name" } },
    { title: "金额", scopedSlots: { customRender: "money" } },
    { title: "取拍时间", dataIndex: "take_time" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "备注", scopedSlots: { customRender: "remark" } },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  mounted() {
    this.loadData();
  }
}
